import { cx } from '../../utils/cx';
import { formatDateTime, formatTimeAgo } from '../../utils/formatting';
import Tooltip, { TooltipTrigger } from '../base/Tooltip/Tooltip';

interface ISyncStatusProps {
  className?: string;
  lastSyncedAt?: string | null;
  addPrefix?: boolean;
  size?: 'sm' | 'xs';
}

const SyncStatus = ({ className, lastSyncedAt, addPrefix, size = 'sm' }: ISyncStatusProps) => {
  const syncStatusText = lastSyncedAt ? formatTimeAgo(lastSyncedAt) : 'n/a';
  const tooltipText = lastSyncedAt ? formatDateTime(lastSyncedAt) : 'Never synced';

  let bubbleColorClass = 'bg-success-solid';
  if (!lastSyncedAt) {
    bubbleColorClass = 'bg-fg-quaternary';
  } else {
    const date = new Date(lastSyncedAt);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays >= 14) {
      bubbleColorClass = 'bg-error-solid';
    } else if (diffDays >= 7) {
      bubbleColorClass = 'bg-warning-solid';
    }
  }

  const textSizeClass = size === 'xs' ? 'text-xs' : 'text-sm';

  return (
    <Tooltip title={tooltipText}>
      <TooltipTrigger className={className}>
        <div className="flex items-center gap-1">
          <div className={cx('size-2 shrink-0 rounded-full', bubbleColorClass)} />
          <div className={cx('text-tertiary', textSizeClass)}>
            {addPrefix && <span>Last sync </span>}
            <span>{syncStatusText}</span>
          </div>
        </div>
      </TooltipTrigger>
    </Tooltip>
  );
};

export default SyncStatus;
